/* src/app/modules/invoice/invoice/invoice-dialog-facturae.component.css */
.fe-header-text {
  min-width: 0;
  padding-right: 32px;
}
.fe-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 16px;
}
.fe-notice--warn {
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
}
.fe-notice--warn mat-icon {
  color: #d97706;
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}
.fe-section {
  margin-bottom: 16px;
}
.fe-section__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #6b7280;
  margin-bottom: 8px;
}
.fe-section__title mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
}
.fe-errors {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.fe-errors li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  padding: 7px 10px;
  background: #fef2f2;
  border-left: 3px solid #dc2626;
  border-radius: 0 4px 4px 0;
  list-style: none;
  margin: 0;
}
.fe-errors li::before {
  content: "\2022";
  color: #dc2626;
  font-weight: 700;
  flex-shrink: 0;
}
.fe-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
}
.fe-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #f9fafc;
  cursor: default;
}
.fe-option__hint {
  font-size: 12px;
  color: #6b7280;
  margin-left: 32px;
  line-height: 1.4;
}
.fe-cert {
  padding: 16px;
  background: #f4f6f8;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.fe-cert__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  margin-bottom: 14px;
}
.fe-cert__title mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  color: #e3fd64;
}
.fe-file-wrap {
  margin-bottom: 12px;
}
.fe-file-input {
  display: none;
}
.fe-file-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1.5px dashed #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  width: 100%;
  box-sizing: border-box;
}
.fe-file-label:hover {
  border-color: #e3fd64;
  background: #f9ffe0;
  color: #4d7a00;
}
.fe-file-label mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.fe-password {
  width: 100%;
}
.fe-file-error {
  margin-top: 6px;
}
/*# sourceMappingURL=invoice-dialog-facturae.component.css.map */
